import { fetcher } from '@commenda/utils';

export const deleteBusinessEntity = async (businessEntityId: number) => {
  const response = await fetcher(`business-entities/${businessEntityId}`, {
    method: 'DELETE',
  });

  return response;
};
